<div id="admin-menu-body">
    <div class="quickview-label">Client Identities</div>
    <div *ngIf="initControlsFlag" class="form-section" [formGroup]="identifiers">
        <div class="formControlBlock">
            <div class="quickview-label" *ngIf="action === 'View'">HMDA LEI</div>
            <div class="recordView-value" *ngIf="action === 'View'">
                {{ idHmdaLEI?.value }}
            </div>
            <div *ngIf="action !== 'View'">
                <mat-form-field class="form-field" appearance="outline">
                    <mat-label>HMDA LEI</mat-label>
                    <input matInput formControlName="idHmdaLEI" type="text" outlined />
                </mat-form-field>
                <validator [control]="idHmdaLEI" [name]="'HMDA'"></validator>
            </div>
        </div>
        <div class="formControlBlock">
            <div class="quickview-label" *ngIf="action === 'View'">Client NMLS ID</div>
            <div class="recordView-value" *ngIf="action === 'View'">
                {{ idNMLS?.value }}
            </div>
            <div *ngIf="action !== 'View'">
                <mat-form-field class="form-field" appearance="outline">
                    <mat-label>Client NMLS ID</mat-label>
                    <input matInput formControlName="idNMLS" type="text" outlined />
                </mat-form-field>
                <validator [control]="idNMLS" [name]="'NMLS'"></validator>
            </div>
        </div>
        <div class="formControlBlock">
            <div class="quickview-label" *ngIf="action === 'View'">Analytics ID</div>
            <div class="recordView-value" *ngIf="action === 'View'">
                {{ idAnalytics?.value }}
            </div>
            <div *ngIf="action !== 'View'">
                <mat-form-field class="form-field" appearance="outline">
                    <mat-label>Analytics ID</mat-label>
                    <input matInput formControlName="idAnalytics" type="text" outlined />
                </mat-form-field>
                <validator [control]="idAnalytics" [name]="'Analytic ID'"></validator>
            </div>
        </div>
        <div class="form-section">
            <div class="quickview-label">
                <div class="quickview-label">Employee Identities</div>
            </div>
            <div formArrayName="employeeIdentifiers" class="identifierList form-section">
                <table>
                    <tbody>
                        <tr class="column-headers">
                            <td>Name</td>
                            <td>Integration Field</td>
                            <td>Description</td>
                            <td>Active</td>
                            <td>Primary For UI</td>
                        </tr>
                        <tr
                            *ngFor="
                                let employeeIdentity of employeeIdentifiers.controls;
                                let i = index
                            "
                            [formGroupName]="i"
                        >
                            <td>
                                <mat-form-field
                                    appearance="none"
                                    kendoTooltip
                                    [title]="employeeIdentity.get('identifierType').value"
                                    class="column-table-data"
                                >
                                    <input
                                        formControlName="identifierType"
                                        matInput
                                        [readonly]="true"
                                    />
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field
                                    appearance="none"
                                    kendoTooltip
                                    [title]="employeeIdentity.get('identifierDescription').value"
                                    class="column-table-data"
                                >
                                    <input
                                        formControlName="identifierDescription"
                                        matInput
                                        [readonly]="true"
                                    />
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field
                                    appearance="outline"
                                    kendoTooltip
                                    [title]="
                                        'Input a useful description for this identifier, it will appear on employee records.'
                                    "
                                >
                                    <input
                                        formControlName="integrationSourceDesc"
                                        matInput
                                        [readonly]="this.action == 'View'"
                                    />
                                </mat-form-field>
                                <validator
                                    [control]="employeeIdentity.get('integrationSourceDesc')"
                                    [name]="'Identity Description'"
                                    [topOffset]="-20"
                                ></validator>
                            </td>
                            <td>
                                <p-checkbox
                                    formControlName="isActive"
                                    [binary]="true"
                                    [disabled]="
                                        this.action == 'View' ||
                                        employeeIdentity.get('isPrimaryForEmployeeIdentifier').value
                                    "
                                />
                                <label>isActive</label>
                            </td>
                            <td>
                                <p-checkbox
                                    #checkbox
                                    formControlName="isPrimaryForEmployeeIdentifier"
                                    [disabled]="true"
                                    binary="true"
                                    inputId="isPrimaryCheckbox"
                                    (onChange)="clickIsPrimary(checkbox)"
                                >
                                </p-checkbox>
                                <label
                                    for="isPrimaryCheckbox"
                                    pTooltip="This is the identifier that will appear on all displays and reports."
                                >
                                    isPrimaryForEmployeeIdentifier
                                </label>
                            </td>
                            <input
                                formControlName="clientIntegrationSourceKey"
                                style="display: none"
                            />
                        </tr>
                    </tbody>
                </table>
                <div [hidden]="this.action == 'View'">
                    <button
                        mat-icon-button
                        type="button"
                        [matMenuTriggerFor]="menu"
                        aria-label="Example icon-button with a menu"
                    >
                        <mat-icon fontSet="fa" fontIcon="fa-plus"></mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button
                            *ngFor="
                                let identifierType of clientIdentifierTypesNonEntry;
                                let i = index
                            "
                            mat-menu-item
                            (click)="clickIdentifierType(i)"
                        >
                            {{ identifierType.identifierType }}
                        </button>
                    </mat-menu>
                </div>
            </div>
        </div>
    </div>
</div>
<br />
